import { Grid } from '@mui/material'
import { useCreditApplicationData } from '@src/contexts/CreditApplicationContext'
import { useGetMerchantById } from '@src/data/api/merchant/merchant-api'
import { useCreateMessage } from '@src/data/api/message/message-api'
import { reportErrorToConsole } from '@src/services/error-logger'
import { useEffect, type JSX } from 'react'
import { useParams } from 'react-router-dom'
import { CreditApplicationMessage } from '../../data/types'
import MessageHeader from './components/MessageHeader'
import MessageList from './components/MessageList'

const CreditApplicationMessagePage = (): JSX.Element | null => {
  const { id } = useParams()

  const [createMessage] = useCreateMessage()

  const { creditApplication: currentApplication, messages } = useCreditApplicationData()
  const [merchant] = useGetMerchantById(currentApplication?.merchantId ?? '')

  useEffect(() => {
    if (currentApplication) {
      document.title = `${currentApplication.applicant.firstName} ${currentApplication.applicant.lastName}`
    }
  }, [currentApplication])

  const onSave = async (data: Partial<CreditApplicationMessage>) => {
    data.creditApplicationId = id
    data.financingProgramId = currentApplication?.financingProgramId
    try {
      await createMessage(data)
    } catch (error) {
      reportErrorToConsole(error)
    }
  }
  return (
    <div style={{ marginBottom: 25 }}>
      <Grid container spacing={2} alignItems="center" size={12}>
        {currentApplication && merchant && (
          <MessageHeader merchant={merchant} currentApplication={currentApplication} />
        )}
        <Grid size={12}>
          <MessageList messages={messages} onSave={onSave} />
        </Grid>
      </Grid>
    </div>
  )
}

export default CreditApplicationMessagePage
